import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

import Image from "src/components/atoms/image/Image";
import ImagePlaceholder from "src/components/atoms/imagePlaceholder/ImagePlaceholder";

import "./RecipeCard.scss";

import { RecipeFieldTypes } from "src/types/contentfulTypes";

interface RecipeCardType {
  recipe: RecipeFieldTypes;
}

const Recipe = ({ recipe }: RecipeCardType) => {
  const { thumbnailImage, slug, cooking_time, name } = recipe;
  const onRecipeClick = () => {
    ReactGA.event({
      category: "Recipe",
      action: "Recipe card clicked",
      label: slug,
    });
  };

  return (
    <li className="recipe-card">
      <Link
        className="recipe-card__link shadow"
        to={`/recipe/${slug}`}
        onClick={onRecipeClick}
      >
        <div className="recipe-card__top">
          {thumbnailImage?.url ? (
            <Image imageObj={thumbnailImage} imageClass="recipe-card__image" />
          ) : (
            <ImagePlaceholder classes="image-placeholder--thumbnail" />
          )}
        </div>
        <div className="recipe-card__bottom">
          <span className="recipe-card__time">{cooking_time} mins</span>
          <h3 className="recipe-card__title">{name}</h3>
        </div>
      </Link>
    </li>
  );
};

export default Recipe;
